import { useState } from "react";
import { Button, Card } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { CiEdit, CiTrash } from "react-icons/ci";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import * as FaIcons from "react-icons/fa";
import { IoAddCircleOutline } from "react-icons/io5";
import Swal from "sweetalert2";

// Fungsi untuk load icon berdasarkan string
const loadIcon = (iconName) => {
  const IconComponent = FaIcons[iconName]; // Ambil dari react-icons
  return IconComponent ? <IconComponent size={24} /> : null; // Default null kalau ga ada
};

const CategoriesTable = ({ categories, onEdit, onDelete, updateOnActive }) => {
  const [selectedRows, setSelectedRows] = useState(false);
  const [toggledClearRows, setToggleClearRows] = useState(false);

  const handleChange = ({ selectedRows }) => {
    setSelectedRows(selectedRows);
  };

  const handleClearRows = () => {
    setToggleClearRows(!toggledClearRows);
  };

  const handleToggleStatus = async (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to change status to ${
        row.active === 1 ? "Inactive" : "Active"
      }?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const updatedStatus = row.active == 1 ? 0 : 1;

          updateOnActive(row.id, { id: row.id, active: updatedStatus });
          Swal.fire("Updated!", "Status has been updated.", "success");
        } catch (error) {
          console.error("Failed to update status", error);
          Swal.fire("Error!", "Failed to update status.", "error");
        }
      }
    });
  };

  const columns = [
    {
      name: "No.", // Serial Number Column
      selector: (row, index) => index + 1,
      sortable: true,
      width: "60px", // Optional: Adjusts the width
    },
    { name: "Name", selector: (row) => row.name, sortable: true },
    {
      name: "Icon",
      selector: (row) => loadIcon(row.icon),
    },
    {
      name: "Active",
      cell: (row) => (
        <span
          style={{
            cursor: "pointer",
            color: row.active === 1 ? "green" : "red",
          }}
          onClick={() => handleToggleStatus(row)}
        >
          {row.active === 1 ? <FaCheckCircle /> : <FaTimesCircle />}{" "}
          {row.active === 1 ? "Active" : "Inactive"}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <div style={{ display: "flex", justifyContent: "center", gap: "5px" }}>
          <Button
            variant="outline-warning"
            size="sm"
            onClick={() => onEdit(row)}
          >
            <CiEdit size={16} />
          </Button>
          <Button
            variant="outline-danger"
            size="sm"
            onClick={() => onDelete(row)}
          >
            <CiTrash size={16} />
          </Button>
        </div>
      ),
      center: true, // Ensures alignment within DataTable
      width: "150px", // Adjust width if needed
    },
  ];

  const customStyles = {
    headCells: {
      style: {
        fontSize: "14px", // Adjust header font size
        fontWeight: "bold",
      },
    },
    cells: {
      style: {
        fontSize: "12px", // Adjust cell font size
        padding: "0px",
        margin: "0px",
      },
    },
    rows: {
      style: {
        minHeight: "35px", // Minimum row height
        maxHeight: "35px", // Maximum row height (optional)
      },
    },
  };

  return (
    <>
      {selectedRows.length > 0 && (
        <Button Tooltip={"test"} variant="outline-danger" className="me-1 mb-2">
          <CiTrash size={32} />
        </Button>
      )}
      <Card>
        <Card.Body>
          <DataTable
            title="Categories"
            columns={columns}
            data={categories}
            pagination
            responsive
            highlightOnHover
            customStyles={customStyles}
            defaultSortFieldId={1}
          />
        </Card.Body>
      </Card>
    </>
  );
};

export default CategoriesTable;
